import { Component, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { CustomValidators } from "src/app/shared/services/custom-validators";
import Swal from "sweetalert2";
import { AdminService } from "../../admin/admin-service";
import { AuthService } from "../../services/auth-services.service";
import { StorageService } from "../../services/storage.service";
import { StorageKey } from "../../storage.model";

@Component({
  selector: "app-change-password",
  templateUrl: "./change-password.component.html",
  styleUrls: ["./change-password.component.scss"],
})
export class ChangePasswordComponent implements OnInit {
  public today: any;
  public frmSignup: FormGroup;

  public toggle = true;
  public toggleOld = true;
  public toggleNew = true;
  public formGroup: FormGroup;
  public userId: string;
  id: any;
  token: string;
  user: any;
  principal: any;
  client: any;

  constructor(
    private formBuilder: FormBuilder,
    private toast: ToastrService,
    private router: Router,
    private storeSvc: StorageService,
    private service: AdminService,
    private auth: AuthService,
    private route: ActivatedRoute
  ) {
    this.id = this.route.snapshot.params["id"];
    this.token = JSON.parse(localStorage.getItem("userInfo"));
    if (this.token) {
      this.client = this.token["data"].principal;
    }
  }

  ngOnInit(): void {
    this.today = new Date().getFullYear();
    this.initForm();
  }

  initForm() {
    this.formGroup = this.formBuilder.group(
      {
        newPassword: [
          "",
          Validators.compose([
            Validators.required,
            CustomValidators.patternValidator(/\d/, { hasNumber: true }),
            CustomValidators.patternValidator(/[A-Z]/, {
              hasCapitalCase: true,
            }),
            CustomValidators.patternValidator(/[a-z]/, {
              hasSmallCase: true,
            }),
            CustomValidators.patternValidator(
              /[ !@#$%^&*()_+\-=\[\]{};':"\\|,<>\/?]/,
              {
                hasSpecialCharacters: true,
              }
            ),
            Validators.minLength(8),
          ]),
        ],
        confirmPassword: ["", Validators.compose([Validators.required])],
        oldPassword: ["", Validators.required],
      },
      {
        validator: CustomValidators.passwordMatchValidator,
      }
    );
  }

  /**
   * reset a default password on the first login attempt
   * @param value
   */
  resetPassword(value: any) {
    const payload = {
      email: this.client.id,
      oldPassword: value.oldPassword,
      newPassword: value.newPassword,
    };
    if (
      value.newPassword === value.confirmPassword &&
      value.oldPassword !== value.newPassword
    ) {
      this.service.changePassword(payload).subscribe((response) => {
        if (response.code === 200) {
          this.router.navigate(["/login"]);
          this.auth.logout();
          //Swal.fire(response.description, "", "success");
        } else {
          // Swal.fire(response.description, "", "error");
        }
      });
    } else {
      this.toast.info(
        "Old Password Must No be Similar to New Password",
        "Warning!",
        {
          timeOut: 5000,
        }
      );
    }
  }

  changePassword(value: any) {
    const payload = {
      id: this.id,
      oldPassword: value.oldPassword,
      newPassword: value.newPassword,
    };
    if (
      value.newPassword === value.confirmPassword &&
      value.oldPassword !== value.newPassword
    ) {
      this.service.changePassword(payload).subscribe((response) => {
        if (response.code === 200) {
          //Swal.fire(response.description, "", "success");
          this.router.navigate(["/login"]);
          this.auth.logout();
        } else {
          // Swal.fire(response.description, "", "error");
        }
      });
    } else {
      this.toast.info(
        "Old Password Must No be Similar to New Password",
        "Warning!",
        {
          timeOut: 5000,
        }
      );
    }
  }
}
